import { render, staticRenderFns } from "./main-table.vue?vue&type=template&id=eb05977e&scoped=true&"
import script from "./main-table.js?vue&type=script&lang=js&"
export * from "./main-table.js?vue&type=script&lang=js&"
import style0 from "./main-table.scss?vue&type=style&index=0&id=eb05977e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb05977e",
  null
  
)

export default component.exports